export const ARTICLE_DOCUMENT_TITLE_MAX_LENGTH = 60

const BRAND_SUFFIX = ' | Sidewisp'

function codePoints(value) {
  return Array.from(value)
}

export function articleDocumentTitle(articleTitle) {
  const normalized = String(articleTitle ?? '').replace(/\s+/g, ' ').trim()
  const availableLength = ARTICLE_DOCUMENT_TITLE_MAX_LENGTH - codePoints(BRAND_SUFFIX).length
  const titleCharacters = codePoints(normalized)

  if (titleCharacters.length <= availableLength) return `${normalized}${BRAND_SUFFIX}`

  const truncatedLength = availableLength - 1
  let truncated = titleCharacters.slice(0, truncatedLength).join('')
  const wordBoundary = truncated.lastIndexOf(' ')
  if (wordBoundary >= Math.floor(truncatedLength * 0.6)) truncated = truncated.slice(0, wordBoundary)
  truncated = truncated.replace(/[\s,:;.!?…—-]+$/u, '')

  return `${truncated}…${BRAND_SUFFIX}`
}
